/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Empty_Noisy_Myna_BreatheInputs */

const fr_empty_noisy_myna_breathe = /** @type {(inputs: Empty_Noisy_Myna_BreatheInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechercher un utilisateur`)
};

/**

* @param {Empty_Noisy_Myna_BreatheInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const empty_noisy_myna_breathe = /** @type {((inputs?: Empty_Noisy_Myna_BreatheInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Empty_Noisy_Myna_BreatheInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_empty_noisy_myna_breathe(inputs)
});